<template>
  <sdCards :title="$t('pages.apps.modules.widget.title')">
    <a-table :columns="columns" :data-source="data" size="small">
      <template #action="{ record }">
        <a-space v-if="record.id">
          <router-link :to="'/applications/detail/' + app_id + '/modules-widget-edit/' + record.id">
            <a-button>
              <template #icon> <sdFeatherIcons type="edit" /> </template>
            </a-button>
          </router-link>
          <a-button @click="deleteModule(record.id)">
            <template #icon> <sdFeatherIcons type="trash-2" /> </template>
          </a-button>
        </a-space>
      </template>
    </a-table>
    <br />
    <router-link :to="{ name: 'detail-module-widget-new' }">
      <sdButton size="small" type="primary">
        <sdFeatherIcons type="plus" size="14" />
        {{ $t('common.add-new') }}
      </sdButton>
    </router-link>
  </sdCards>
</template>

<script>
export default {
  name: 'BlankPage',
  data() {
    return {
      app_id: this.$route.params.id,
      type: 'widget',
      data: [],
      columns: [
        {
          dataIndex: 'id',
          key: 'id',
          title: '#',
        },
        {
          title: this.$t('pages.apps.modules.widget.size'),
          dataIndex: 'size',
          key: 'size',
        },
        {
          title: this.$t('common.action'),
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  methods: {
    deleteModule(id) {
      if (!confirm(this.$t('common.confirm-delete'))) {
        return;
      }

      const formData = {
        id: this.app_id,
        type: this.type,
        module_id: id,
      };
      this.$appAxios.post(this.$endpoints.app_module_delete, formData).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
          this.$store.dispatch('application/get', this.app_id);
          this.getData();
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
    getData() {
      this.data = [];

      const formData = {
        id: this.app_id,
        type: this.type,
      };
      this.$appAxios.post(this.$endpoints.app_module_get, formData).then((resp) => {
        if (resp.data.status) {
          var modules = resp.data.data;
          var _this = this;
          modules.forEach(function (item, index) {
            _this.data.push({
              key: index,
              id: item.id,
              size: item.size,
            });
          });
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>